import { useNavigate, useSearchParams } from "react-router-dom";

const useNavigateWithParams = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  return (path: string, additionalParams: Record<string, string | number> = {}) => {
    const currentParams = Object.fromEntries(searchParams.entries());
    const mergedParams = { ...currentParams, ...additionalParams };
    const stringParams = Object.fromEntries(Object.entries(mergedParams).map(([key, value]) => [key, value.toString()]));

    const paramsString = new URLSearchParams(stringParams).toString();

    navigate(paramsString ? `${path}?${paramsString}` : path);
  };
};

export default useNavigateWithParams;
